<template>
  <div class="team-card mb-30" @click.prevent="openTeamPopup()">
    <div class="h-100 team-card-content p-3 border">
      <div class="title  mb-2 align-items-center d-flex justify-content-between">
        <h2 class="mb-0 mr-3">{{cardTitle}}</h2>

        <div v-if="team.users" class="ml-auto counts mr-2 mb-2 d-flex">
          <div class="membercount w-auto mr-3">
            <span class="text-muted mr-1"><i class="fa-fw fas fa-user-friends"></i></span>
            {{team.users.length}}
          </div>
          <div class="admincount text-md w-auto position-relative ">
            <div class="team-info position-static d-flex border-0">
              <span class="text-muted mr-1"><i class="fa-fw far fa-clipboard"></i></span>
              <span class="count">{{team.managedBy.length}}</span>
              <div class="team-info-container-card" v-if="team.information || team.managedBy">
                <template v-if="team.managedBy">
                  <p class="font-italic small m-0 managers">{{$t('message.managed_by')}}</p>
                  <div class="m-0 managers mt-1 d-block text-left">
                    <div class="text-left p-0 d-block" v-for="manager in team.managedBy">- {{manager.fullname}}</div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class=" mb-0 small" v-if="!teamHasData">{{$t('message.no_results_yet')}}.</p>
      <div class="row">
        <div
          :class="team.Information ? 'col-md-6' : 'col-md-12'"
          class="info">
          {{team.Information ? team.Information : ''}}
          <!--          <ul class="pl-2 mb-0 team-insights">-->
          <!--            <li class="mb-3">-->
          <!--              <p class="mb-1">Insight 1</p>-->
          <!--              <span class="small">-->
          <!--                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
          <!--                                            Autem blanditiis pariatur quis repudiandae, veritatis voluptatum.-->
          <!--                                          </span>-->
          <!--            </li>-->
          <!--            <li class="mb-3">-->
          <!--              <p class="mb-1">Insight 2</p>-->
          <!--              <span class="small">-->
          <!--                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
          <!--                                            Adipisci atque cum cumque, id nostrum sint!-->
          <!--                                          </span>-->
          <!--            </li>-->
          <!--            <li class="mb-3">-->
          <!--              <p class="mb-1">Insight 3</p>-->
          <!--              <span class="small">-->
          <!--                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
          <!--                                            Beatae itaque modi placeat sint temporibus vel?-->
          <!--                                          </span>-->
          <!--            </li>-->
          <!--          </ul>-->

        </div>

        <div
          :class="team.Information ? 'col-md-6' : 'col-md-12'"
          class="chart">
          <div class="chart-container">
            <generic-chart
              style="height:250px; max-height:250px; min-height:200px"
              v-if="vitaminLabels.length && vitaminData.length"
              :type="'polarArea'"
              :legend="false"
              :chart-data="[vitaminData]"
              :chart-labels="vitaminLabels"
              :name="safeName(type+'-card-'+team.id)"
            ></generic-chart>
          </div>

        </div>

        <div class="col-md-12 pt-3  pb-3">
          <div class="border-bottom-grey">

          </div>
        </div>

        <div class="col-md-12">
          <div class="vip-scores row">
            <div class="col-md-6">
              <div class="score score-medium score-medium-three"
                   :class="company ? ('score-c-'+truncate(company.vipscore,0)+' score-bc-'+truncate(company.vipscore,0)) : null">
                <div :class="company ? (company.vipscore % 1 > 0 ? 'small-score' : '') : ''"
                     class="content">{{company ? truncate(company.vipscore,1) : '--'}}
                </div>
              </div>
              <div class="mb-0 mt-2 label-centered">{{ $t('message.company_score') }}</div>
            </div>
            <div class="col-md-6">

              <div class="score score-medium score-medium-three"
                   :class="team ? ('score-c-'+truncate(team.vipscore,0)+' score-bc-'+truncate(team.vipscore,0)) : null">
                <div :class="team ? (team.vipscore % 1 > 0 ? 'small-score' : '') : ''"
                     class="content">
                  {{team ? truncate(team.vipscore,1) : '--'}}
                </div>
              </div>
              <div class="mb-0 mt-2 label-centered">{{ $t('message.team_score') }}</div>

            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import GenericChart from "../Charts/GenericChart"
  import store from "../../store/store";

  export default {
    components: {
      GenericChart
    },
    mounted() {
      if (!this.team.Title) {
        this.team.Title = this.capitalize(this.$t('message.' + this.team.type)) + ': ' + this.cardTitle
      }
    },
    methods: {
      openTeamPopup() {
        if(this.teamHasData){
          this.$emit('clickedTeam', this.team);
        }
      }
    },
    computed: {
      teamHasData() {
        return !!(this.team.data);
      },
      type() {
        if (this.team.parent) {
          return 'team'
        }
        if (this.team.subtype) {
          return 'demographic'
        }
        return 'company'
      },
      cardTitle() {
        let title = '';
        if (this.team.Title) {
          title = this.team.Title
        }

        if (this.team.subtype) {
          title = this.team.subtype;
          if (this.team.subtype === 'null') {
            title = this.$t('message.unknown')
          } else {
            if (this.team.type === 'country') {
              title = this.$t('message.country_' + this.team.subtype);
            }
            if (this.team.type === 'education') {
              title = this.$t('message.' + this.team.subtype);
            }
            if (this.team.type === 'gender') {
              switch (this.team.subtype) {
                case 'm':
                  title = this.$t('message.male');
                  break;
                case 'f':
                  title = this.$t('message.female');
                  break;
                case 'x':
                  title = this.$t('message.other');
                  break;
              }
            }
          }
          title = this.capitalize(title)
        }
        return title
      },
      company() {

        return store.getters.getCompany
      },
      vitaminLabels() {
        let labels = [];
        this.vitamins.forEach(vitamin => {
          labels.push(this.localizedField(vitamin,'Title'))
        });
        return labels
      },
      vitaminData() {
        let returnData = [];
        if (this.team.data) {
          let vitaminscores = this.team.data.children;
          vitaminscores.forEach(vitamin => {
            if (this.vitaminScores[vitamin.id]) {
              returnData.push(this.truncate(vitamin.average, 2))
            }
          });
        }

        return returnData
      }
    },
    props: {
      vitaminScores: {
        type: Object,
        default() {
          return {}
        }
      },
      vitamins: {
        type: Array,
        default() {
          return []
        }
      },
      team: {
        type: Object,
        default() {
          return null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Review/TeamCard.vue